export const ERROR_MESSAGES = {
  TOKEN_EXPIRED: 'Your session has expired. Please log in again.',
  SESSION_EXPIRED: 'Session expired or invalid',
  INVALID_SESSION_ID: 'Session expired or invalid',
  INVALID_EXPIRED_SESSION: 'INVALID_SESSION_ID: Invalid or expired session ID.',
  EXPIRED_ACCESS_REFRESH_TOKEN: 'expired access/refresh token',
  CANNOT_REFRESH_TOKEN: 'This token cannot be refreshed.',
  FAIL_REFRESHING_TOKEN: 'Failed to refresh token',
  MALFORMED_QUERY: 'The query is malformed, please contact with support',
};

export const ERR_SYNCING_CONFIG_FORM = 'ERR_SYNCING_CONFIG_FORM';
export const ERR_CLEANING_FORM_DB = 'ERR_CLEANING_FORM_DB';

export const CRM_NON_AUTH_SESSION_ERRORS = [
  ERR_SYNCING_CONFIG_FORM,
  ERROR_MESSAGES.MALFORMED_QUERY,
];
